import './App.css'
import './login.css'
import './features/asset-configuration/assetConfigStyle.css'
import { WebSocketProvider } from './contexts/WebSocketContext'
import WebSocketConnectionManager from './components/WebSocketConnectionManager'
import { BrowserRouter as Router } from 'react-router-dom'
import Main from './features/dashboard/components/MainComponent'
import React from 'react'
import { createTheme } from '@mui/material/styles'
import { ThemeProvider } from '@mui/material'
import { ToastContainer } from 'react-toastify'

const theme = createTheme({
  palette: {
    primary: {
      main: '#64C3FF'
    }
  }
})

function App (): JSX.Element {
  return (
    <WebSocketProvider>
      <WebSocketConnectionManager>
        <ThemeProvider theme={theme}>
          <div>
            <Router>
              <Main />
            </Router>
          </div>
        </ThemeProvider>
        <ToastContainer />
      </WebSocketConnectionManager>
    </WebSocketProvider>
  )
}

export default App
